<template>
  <div v-if="activePage.id && pages.length > 0">
    <div class="admin__header">
      <div class="admin-survey-pages">
        <steps :items="pages" :active-item="activePage" :click-event="goToPage" v-if="pages.length > 1"></steps>
        <h2 v-else>{{ pages[0].title }}</h2>
      </div>
      <button class="button button--inline" @click="deletePage">Delete Page</button>
      <router-link :to="{ name: 'admin-edit-page', params: { pageId: activePage.id } }" class="button button--inline">Edit Page</router-link>
      <router-link :to="{ name: 'admin-new-page' }" class="button button--inline">Add Page</router-link>
    </div>

    <page-show :edit-mode="true"></page-show>
  </div>
  <no-items v-else
    :parent="activeSurvey.title"
    name="Page"
    icon="desktop_windows"
    new-link="admin-new-page"
  ></no-items>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import NoItems from '@/components/admin/NoItems';
  import Steps from '@/components/Steps';
  import PageShow from '@/components/admin/pages/Show';

  export default {
    name: 'admin-pages',

    components: {
      'no-items': NoItems,
      'page-show': PageShow,
      steps: Steps,
    },

    computed: {
      ...mapState('admin', {
        pages: state => state.page.pages,
      }),

      ...mapGetters('admin', [
        'activeSurvey',
        'activePage',
      ]),
    },

    watch: {
      pages() {
        if (!this.activePage.id && this.pages && this.pages.length > 0) {
          this.setActivePage(this.pages[0].id);
        }
      },
    },

    methods: {
      ...mapMutations('admin', [
        'setActivePage',
      ]),

      ...mapActions('admin', [
        'fetchFields',
      ]),

      goToPage(page) {
        this.setActivePage(page.id);
      },

      deletePage() {
        /* eslint-disable no-alert */
        if (confirm(
          `Are you sure you want to delete ${this.activePage.title}?`)) {
          this.$store.dispatch('admin/deletePage', { surveyId: this.activeSurvey.id, pageId: this.activePage.id });
        }
      },
    },

    created() {
      if (this.$route.query.page) {
        this.setActivePage(parseInt(this.$route.query.page));
      }
    },
  };
</script>
